































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BSpinner,
  BBadge,
} from "bootstrap-vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Entreprise } from "@/api/models/adherents/adherent";
import AddOpportunite from './AddOpportunite.vue'
import UpdateOpportunite from './UpdateOpportunite.vue'
import CreateContact from '../contacts/CreateContact.vue'
import ViewOpportunite from './ViewOpportunite.vue'
import { ShortOpportunite } from "@/api/models/opportunites/opportunite";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    BSpinner,
    AddOpportunite,
    UpdateOpportunite,
    CreateContact,
    ViewOpportunite,
  },
})
export default class ListOpportunitesAdherent extends Vue {
  @Prop({ required: true }) adherent!: Entreprise;
  perPage = 25;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewOpportuniteSidebarActive = false
  isAddNewContactSidebarActive = false
  isUpdateOpportuniteSidebarActive = false;
  isViewOpportuniteModalActive = false;
  selectedOpportuniteId = "";
  isLoadingOpportunites = false;
  timeout: any = null;
  isSortDirDesc = false;
  sortBy = "libelle";

  listStatuts: { code: string; libelle: string; }[] = [];

  tableColumns = [
    { key: "opportuniteId", label:"Id", sortable: true },
    { key: "libelle", label: "Libellé", sortable: true },
    { key: "naturesOffre", label: "Nature(s)", sortable: true },
    { key: "responsableCompleteNom", label: "Responsable", sortable: true },
    { key: "statut", sortable: true },
    { key: "actions", sortable: false }
  ];
  paginatedListOpportunites = new PaginatedList<ShortOpportunite>();

  async created() {
    const editOpportuniteId = this.$route.query.editOpportunite as string
    if (editOpportuniteId) {
        setTimeout(() => {
          this.selectedOpportuniteId = editOpportuniteId
          this.isUpdateOpportuniteSidebarActive = true
        
        }, 500)
    }

    await this.loadStatuts();
    await this.loadListOpportunite({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListOpportunites.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListOpportunites.items.length
    );
  }

  transformToContractOpportunite(opportuniteId: string) {
    this.$emit('transform-to-contract-opportunite', opportuniteId)
  }

  getStatutLibelle(code: string) {
    const statut = this.listStatuts.find((s) => s.code === code);
    return statut ? statut.libelle : code;
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListOpportunite({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    });
  }

  async searchOpportunite() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListOpportunite({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        orderBy: this.sortBy,
        orderByDescending: this.isSortDirDesc
      })
    }, 1000);
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    };
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListOpportunite(params);
  }

  selectOpportunite(opportuniteId: string) {
    this.selectedOpportuniteId = opportuniteId;
    this.isUpdateOpportuniteSidebarActive = true;
  }

  async loadListOpportunite(params: any) {
    if (!params || params?.reset) {
      this.paginatedListOpportunites = new PaginatedList<ShortOpportunite>();
    }
    this.isLoadingOpportunites = true;
    await this.$http.myressif.entreprises
      .getListOpportunitesByEntrepriseId(
        this.$route.params.id,
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending
      )
      .then((response: PaginatedList<ShortOpportunite>) => {
        this.paginatedListOpportunites = response;
      })
      .finally(() => {
        this.isLoadingOpportunites = false;
      });
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cette opportunité ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.entreprises
      .deleteOpportuniteEntreprise(this.$route.params.id, id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un opportunite",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.loadListOpportunite(null);
      });
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    var response: {code: string, libelle: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }

  async loadStatuts() {
    this.listStatuts = await this.loadParametre('opportunites_statut')
  }

  openContactSidebar() {
    const modals = document.querySelectorAll('.modal')
    const backdrops = document.querySelectorAll('.modal-backdrop')
    
    modals.forEach((modal: any) => {
      modal.style.display = 'none'
    })
    
    backdrops.forEach((backdrop: any) => {
      backdrop.style.display = 'none'
    })
    
    this.isAddNewContactSidebarActive = true
  }

  onContactSidebarHidden() {
    const modals = document.querySelectorAll('.modal')
    const backdrops = document.querySelectorAll('.modal-backdrop')
    
    modals.forEach((modal: any) => {
      modal.style.display = 'block'
    })
    
    backdrops.forEach((backdrop: any) => {
      backdrop.style.display = 'block'
    })
  }

  refreshContactsInOpportunite() {
    const addOpportuniteComponent = this.$refs.addOpportuniteRef as any
    if (addOpportuniteComponent && addOpportuniteComponent.refreshContacts) {
      addOpportuniteComponent.refreshContacts()
    }
    
    const updateOpportuniteComponent = this.$refs.updateOpportuniteRef as any
    if (updateOpportuniteComponent && updateOpportuniteComponent.refreshContacts) {
      updateOpportuniteComponent.refreshContacts()
    }
  }

  viewOpportunite(item: ShortOpportunite) {
    this.selectedOpportuniteId = item.id || ''
    this.isViewOpportuniteModalActive = true
  }
}
